import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BRAND, GENERAL_URL} from "@prcins/constants";
import {EsignService} from "../services/esign.service";
import {Router} from "@angular/router";
import {LoginService, UtilityProviderService} from "@prcins/utils";

@Component({
  selector: 'prcins-esign',
  templateUrl: './esign.component.html',
  styleUrls: ['./esign.component.css']
})
export class EsignComponent implements OnInit {
  @Input() eligibleForms;
  @Output() eSignCompleted = new EventEmitter();
  @Output() eSignSkipped = new EventEmitter();
  @ViewChild('signature', {static: false}) signature;
  showSpinner = false;
  currentForm;
  currDateTime = new Date();
  brand = localStorage.getItem(BRAND);
  showSkipESignPopup = false;
  showSignatureError = false;
  currentFormIndex = 0;
  faqUrl = GENERAL_URL.resource;
  glossaryUrl = GENERAL_URL.glossary;
  bgUrl = GENERAL_URL.buyersGuide;
  brUrl = GENERAL_URL.billOfRights;
  lobHome = false;
  namedInsureds = [];

  constructor(
    private eSignService: EsignService,
    private router: Router,
    private utilityService: UtilityProviderService,
    private loginService: LoginService
  ) {
  }

  ngOnInit() {
    if (this.eligibleForms && this.eligibleForms.length) {
      this.currentForm = this.eligibleForms[this.currentFormIndex];
      this.currentForm.fullName = this.getFullName(this.currentForm);
      this.lobHome = this.currentForm.variance.lob === 'HO';

      this.populateNamedInsureds();
    }
  }

  private populateNamedInsureds() {
      if (this.currentForm.namedInsured1) {
        sessionStorage.setItem('pni1', JSON.stringify(this.currentForm.namedInsured1));
      }
      if (this.currentForm.namedInsured2) {
        sessionStorage.setItem('pni2', JSON.stringify(this.currentForm.namedInsured2));
      }

      const pni1 = JSON.parse(sessionStorage.getItem('pni1'));
      const pni2 = JSON.parse(sessionStorage.getItem('pni2'));

      if (pni1) {
        this.namedInsureds.push({ name: this.getFullName(pni1) });
      }

      if (pni2) {
        this.namedInsureds.push({ name: this.getFullName(pni2) });
      }
    }

  updateSelectedSigner(event: any) {
    this.currentForm.fullName = event.target.value;
  }

  goBack() {
    this.utilityService.clearAppStorage();
    this.router.navigate(['/login']);
  }

  generateDocURL(form: any) {
    this.eSignService.viewDoc(this.currentForm.policyNumber, form.esignId, form.formId, this.currentForm.token)
      .subscribe(data => {
        const linkSource = 'data:application/pdf;base64,' + data;
        const link = document.createElement("a");
        link.href = linkSource;
        link.download = `${form.formDesc}.pdf`
        link.click();
      }, error => {
        console.error(error);
        this.showSkipESignPopup = true;
      });
  }

  skipESign() {
    this.eSignSkipped.emit();
  }

  submitESign(signature) {
    this.showSignatureError = false;
    this.showSpinner = true;
    if (this.currentForm.fullName.toUpperCase() !== signature.toUpperCase()) {
      this.showSignatureError = true;
      this.showSpinner = false;
      return;
    }

    this.eSignService.submitESign(this.currentForm).subscribe(data => {
      if ((this.currentFormIndex+1) < this.eligibleForms.length) {
        this.currentFormIndex++;
        this.currentForm = this.eligibleForms[this.currentFormIndex];
        this.currentForm.fullName = this.getFullName(this.currentForm);
        this.signature.nativeElement.value = '';
        this.showSpinner = false;
        window.scroll(0, 0);
        this.populateNamedInsureds();
        } else {
        this.eSignCompleted.emit();
        this.showSpinner = false;
      }
    });

  }

  private capitalizeName(name: string): string {
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  private getFullName(person: any): string {
    if (!person) return '';
    const first = this.capitalizeName(person.firstName);
    const middle = person.middleName ? this.capitalizeName(person.middleName) : '';
    const last = this.capitalizeName(person.lastName);
    return [first, middle, last].filter(Boolean).join(' ');
  }
}

